/*
   本地存储技术工具文件
*/


export default {//暴露
   //存
   set(k, val) {
      return localStorage.setItem(k, val)
   },
   //取
   get(k) {
      return localStorage.getItem(k)
   },
   //删除某一个key值
   remove(k) {
      return localStorage.removeItem(k)
   },
   //清空
   clear(k, val) {
      return localStorage.clear()
   },
}